import { CommandPayload } from "src/data/commands";

import { Device } from ".";

export type MdmCommand = {
    id: number;
    fingerprint: string;
    // null for GroupCommands
    device: Device | null;
    created: string;
    creator: string;
    comment: string | null;
    origin: string;
    payload: CommandPayload;
    updated: string;
    status: MdmCommandStatus;
    statuses?: Record<MdmCommandStatus, number>;
    report: string | null;
};

export type MdmCommandStatus = "unknown" | "pending" | "running" | "successful" | "failed" | "received" | "ignored" | "queued";

export const DeviceMdmCommandStatusIcon = {
    unknown: "fas fa-solid fa-calendar-days",
    pending: "fas fa-solid fa-hourglass-start",
    running: "fas fa-solid fa-refresh",
    successful: "fas fa-solid fa-check",
    failed: "fas fa-solid fa-times",
    received: "fas fa-solid fa-database",
    ignored: "fas fa-solid fa-ban",
    queued: "fas fa-solid fa-hourglass-o",
};

export enum MdmCommandOrigin {
    DeviceOrigin = "device/",
    GroupOrigin = "group/",
}

export const MdmCommandOriginIcon = {
    [MdmCommandOrigin.DeviceOrigin]: "fas fa-solid fa-desktop",
    [MdmCommandOrigin.GroupOrigin]: "fas fa-solid fa-sitemap",
};

export enum ComplexCommandNames {
    StartPackage = "startPackage",
    StopPackage = "stopPackage",
    UninstallPackage = "uninstallPackage",
}
